import React from 'react';
import './PickSeatAutomatic.scss';
import NumberInput from 'Components/Shared/NumberInput/NumberInput';
import CategoryDropdown from 'Components/CategoryDropdown/CategoryDropdown';

interface IProps {
  isMaxNumberOfSeats: boolean;
  seatType: Julius.Website.PerformanceSeatTypeViewModel;
  currentSelection?: Julius.Website.SeatRequestViewModel;
  maxNumberOfSeatsPromotion: number;
  onSeatSelection: (selection: Julius.Website.SeatRequestViewModel) => void;
}

class SeatItem extends React.PureComponent<IProps> {

  onQuantityChange = (value: number) => {
    this.props.onSeatSelection({ ...this.getSelection(), numberOfSeats: value });
  }

  onPriceCategoryChange = (priceCategoryID: number) => {
    this.props.onSeatSelection({ ...this.getSelection(), priceCategoryID });
  }

  onSectionChange = (sectionID: number) => {
    this.props.onSeatSelection({ ...this.getSelection(), sectionID });
  }

  getSelection = () => {
    const { currentSelection, seatType } = this.props;

    return currentSelection ? currentSelection : {
      discountID: seatType.discountID,
      sectionID: 0,
      priceCategoryID: seatType.priceCategories[0].id,
      numberOfSeats: 0,
      bypassPromotionCode: false,
    };
  }

  isReducedPrice = () => {
    const { seatType } = this.props;
    const { price, priceDiscounts } = seatType.priceCategories[0];
    if ( priceDiscounts.length > 0 ) {
      if ( price !== priceDiscounts[0].price ) {
        return true;
      }
    }
    return false;
  }
  
  getNumberInputRatio = () => {
    const { seatType: { minNbrSeats } } = this.props;
    if ( minNbrSeats <= 0 ) {
      return 1;
    }
    return minNbrSeats;
  }
  
  isIncrementDisabled = (): boolean => {
    const { isMaxNumberOfSeats } = this.props;
    
    if ( isMaxNumberOfSeats ) {
      return true;
    }

    return false;
  }
  
  render() {
    const { seatType } = this.props;

    if (
      !seatType || 
      !seatType.priceCategories || 
      !seatType.priceCategories.length
    ) {
      return null;
    }

    const { seatType: { name, priceCategories } } = this.props;
    const { isIncrementDisabled } = this;

    const ratio = this.getNumberInputRatio();
    
    const currentSelection = this.getSelection();

    return (
      <div className='seat-item'>
        <div className='sub-title medium-bold'>{ name }</div>
        <CategoryDropdown 
          categories={ priceCategories }
          selectedCategoryID={ currentSelection.priceCategoryID }
          onSelect={ this.onPriceCategoryChange }
        />
        <NumberInput 
          value={ currentSelection.numberOfSeats }
          isIncrementDisabled={ isIncrementDisabled() }
          onChange={ this.onQuantityChange }
          ratio={ ratio }
        />
      </div>
    );
  }
};

export default SeatItem;


// WEBPACK FOOTER //
// ./src/components/PickSeatAutomatic/SeatItem.tsx